import { render, staticRenderFns } from "./AddDepart.vue?vue&type=template&id=05e4c34e&scoped=true&"
import script from "./AddDepart.vue?vue&type=script&lang=js&"
export * from "./AddDepart.vue?vue&type=script&lang=js&"
import style0 from "./AddDepart.vue?vue&type=style&index=0&id=05e4c34e&scoped=true&lang=css&"
import style1 from "./AddDepart.vue?vue&type=style&index=1&id=05e4c34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4c34e",
  null
  
)

export default component.exports